import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import '../../sass/common.scss';

interface Props {
  h?: number
}

export default function Loading(props: Props) {
  const {h} = props;

  return (
    <div
      className={'custom-loading'}
      style={{
        ...(h ? {height: `${h}px`} : {})
      }}
    >
      <CircularProgress style={{color: "#B3682A"}}/>
    </div>
  );
}
